import * as React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
const plans = [{
  id: 1,
  title: "Pro Stunde",
  price: "35€",
  duration: "/ Stunde",
  description: "Perfekt für kurze Meetings, Interviews und schnelle Team-Abstimmungen.",
  buttonText: "Raum buchen",
  badge: "10% Member-Rabatt",
  highlighted: false
}, {
  id: 2,
  title: "Halber Tag",
  price: "120€",
  duration: "/ 4 Stunden",
  description: "Ideal für Workshops, Präsentationen und intensive Brainstorming-Sessions.",
  buttonText: "Raum buchen",
  badge: "15% Member-Rabatt",
  highlighted: true
}, {
  id: 3,
  title: "Ganzer Tag",
  price: "200€",
  duration: "/ 8 Stunden",
  description: "Die beste Wahl für ganztägige Seminare, Offsites und Team-Events.",
  buttonText: "Raum buchen",
  badge: "20% Member-Rabatt",
  highlighted: false
}];
const features = [{
  planId: 1,
  text: "Bis zu 8 Personen"
}, {
  planId: 1,
  text: "High-Speed WLAN"
}, {
  planId: 1,
  text: "Whiteboard & 65\" 4K TV"
}, {
  planId: 2,
  text: "Bis zu 8 Personen"
}, {
  planId: 2,
  text: "High-Speed WLAN"
}, {
  planId: 2,
  text: "Whiteboard & 65\" 4K TV"
}, {
  planId: 2,
  text: "Kaffee & Wasser Flatrate"
}, {
  planId: 3,
  text: "Bis zu 8 Personen"
}, {
  planId: 3,
  text: "High-Speed WLAN"
}, {
  planId: 3,
  text: "Whiteboard & 65\" 4K TV"
}, {
  planId: 3,
  text: "Kaffee & Wasser Flatrate"
}, {
  planId: 3,
  text: "Catering auf Anfrage"
}];
export default function Konferenzraum() {
  return;
}